import { gateway } from "../../../gateway";

export const searchMessages = async ({ q, page = 1, pageSize = 20 }) => {
  try {
    const params = new URLSearchParams();
    params.append("q", q);
    params.append("page", page.toString());
    params.append("pageSize", pageSize.toString());

    const res = await gateway.get(`/messages/search?${params.toString()}`);

    return res.data;
  } catch (error) {
    console.error("Error in searchMessages:", error);
    throw error;
  }
};
